import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { IconSizes } from '@recruitee/user-interface';

@Component({
  selector: 'rt-icon-font',
  standalone: true,
  styleUrls: ['./icon-font.component.less'],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `{{ name }}`,
  host: {
    class: 'material-icons-outlined',
    '[style.font-size.px]': 'IconSizes[size]',
    '[style.color]': '"var(--icon-color-token)"',
  },
})
export class IconFontComponent {
  public readonly IconSizes = IconSizes;

  @Input() public name: string;
  @Input() public size: keyof typeof IconSizes = 'medium';
}
